












































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import '@/globals';
import FilterHelper from '@/services/filter-helper';
import { Community, Experience, Favorite, Topic } from '@/constants';
import { ChipModel, PoiFilterSet } from '@/models/filter';
import { Poi, PoiState } from '@/models/poi';

@Component
export default class PoiFilterPage extends Vue {

    @Prop({ type: Array, default: () => Vue.prototype.$store.pois }) public poiSource: Poi[];
    @Prop(Object) public filterSet!: PoiFilterSet;
    @Prop(Object) public eventTarget!: Vue;

    private clearButtonActive: boolean = false;
    private applyButtonActive: boolean = false;
    private applyButtonText: string = '';
    private tmpPois: Poi[] = [];
    private tmpFilterSet: PoiFilterSet;

    private unlockChips: ChipModel[] = [];
    private topicChips: ChipModel[] = [];
    private experianceChips: ChipModel[] = [];
    private communityChips: ChipModel[] = [];
    private favoriteChips: ChipModel[] = [];

    public async mounted() {
        await this.$store.waitUntilReady();

        // copy filters
        this.tmpFilterSet = FilterHelper.duplicatePoiFilterSet(this.filterSet);
        this.tmpPois = [];

        // init chip models based on filter
        this.initChips();
        this.initChipsByFilterSet();

        // update filtered pois
        this.recalculateFilteredPois();
    }

    private initChips() {
        this.unlockChips = [
            new ChipModel(PoiState.LOCKED, this.$t('poi_state.locked')),
            new ChipModel(PoiState.READY_TO_UNLOCK, this.$t('poi_state.ready')),
            new ChipModel(PoiState.UNLOCKED, this.$t('poi_state.unlocked'))
        ];

        this.topicChips = [
            new ChipModel(Topic.POLITIK, this.$t('poi_topics.1')),
            new ChipModel(Topic.HERRSCHAFT, this.$t('poi_topics.2')),
            new ChipModel(Topic.WIRTSCHAFT, this.$t('poi_topics.3')),
            new ChipModel(Topic.RELIGION, this.$t('poi_topics.4')),
            new ChipModel(Topic.KULTUR, this.$t('poi_topics.5')),
            new ChipModel(Topic.NATUR, this.$t('poi_topics.6')),
            new ChipModel(Topic.GESELLSCHAFT, this.$t('poi_topics.7'))
        ];

        this.experianceChips = [
            new ChipModel(Experience.NORMAL, this.$t('poi_category.1')),
            new ChipModel(Experience.SPECIAL, this.$t('poi_category.2'))
        ];

        this.communityChips = [
            new ChipModel(Community.BALZERS, this.$t('poi_community.BALZERS')),
            new ChipModel(Community.TRIESEN, this.$t('poi_community.TRIESEN')),
            new ChipModel(Community.TRIESENBERG, this.$t('poi_community.TRIESENBERG')),
            new ChipModel(Community.VADUZ, this.$t('poi_community.VADUZ')),
            new ChipModel(Community.SCHAAN, this.$t('poi_community.SCHAAN')),
            new ChipModel(Community.PLANKEN, this.$t('poi_community.PLANKEN')),
            new ChipModel(Community.ESCHEN_NENDELN, this.$t('poi_community.ESCHEN')),
            new ChipModel(Community.GAMPRIN_BENDERN, this.$t('poi_community.GAMPRIN')),
            new ChipModel(Community.RUGGELL, this.$t('poi_community.RUGGELL')),
            new ChipModel(Community.SCHELLENBERG, this.$t('poi_community.SCHELLENBERG')),
            new ChipModel(Community.MAUREN_SCHAANWALD, this.$t('poi_community.MAUREN'))
        ];

        this.favoriteChips = [
            new ChipModel(Favorite.FAVORITE, this.$t('poi_favorites.1')),
            // new ChipModel(Favorite.NON_FAVORITE, 'Nicht Favoriten')
        ];
    }

    private initChipsByFilterSet() {
        this.topicChips.forEach(topicChip => {
            topicChip.checked = !(this.tmpFilterSet.topicFilters.indexOf(topicChip.id) === -1);
        });

        this.communityChips.forEach(communityChip => {
            communityChip.checked = !(this.tmpFilterSet.communityFilters.indexOf(communityChip.id) === -1);
        });

        this.experianceChips.forEach(experianceChip => {
            experianceChip.checked = !(this.tmpFilterSet.experienceFilters.indexOf(experianceChip.id) === -1);
        });

        this.unlockChips.forEach(unlockChip => {
            unlockChip.checked = !(this.tmpFilterSet.unlockFilters.indexOf(unlockChip.id) === -1);
        });

        this.favoriteChips.forEach(favoriteChip => {
            favoriteChip.checked = !(this.tmpFilterSet.favoriteFilters.indexOf(favoriteChip.id) === -1);
        });
    }

    private recalculateFilteredPois() {
        // update cached filtered pois
        this.tmpPois = FilterHelper.getFilteredPois(this.$store, this.poiSource, this.tmpFilterSet);

        // check if there is any filter
        this.applyButtonActive = this.tmpPois.length > 0;

        this.applyButtonText = this.$tc('poi.filter_apply', this.tmpPois.length, { count: this.tmpPois.length });

        this.clearButtonActive = FilterHelper.isPoiFilterSetModified(this.tmpFilterSet);
    }

    private clearAllFilters() {
        // create new empty filterset
        this.tmpFilterSet = FilterHelper.createPoiFilterSet();

        // update chip states
        this.initChipsByFilterSet();

        // update filtered pois
        this.recalculateFilteredPois();

        this.eventTarget.$emit('poiFilterApplied', this.tmpFilterSet, this.tmpPois);

        this.$ga.event({
            eventCategory: 'poi',
            eventAction: 'filterCleared',
        });
    }

    private chipClicked(chip: ChipModel, chipGroup: ChipModel[], filters: string[]) {
        chip.checked = !chip.checked;

        // clean and refill array, fancy js
        filters.splice(0, filters.length);
        filters.unshift(...chipGroup.filter(c => c.checked).map(c => c.id));

        // update results
        this.recalculateFilteredPois();
    }

    private applyFilters() {
        this.eventTarget.$emit('poiFilterApplied', this.tmpFilterSet, this.tmpPois);

        this.$ga.event({
            eventCategory: 'poi',
            eventAction: 'filterApplied',
        });

        this.$f7router.back();
    }
}
